import {
  canonicalNikkeId,
  fallbackNikkeIdentifier,
  nikkeIdentifierCandidates,
} from '../../nikke-catalog/domain/nikkeCatalog.js';

const text = (value) => String(value ?? '').trim();

export function canonicalTetrisNikkeKey(value, catalog = null) {
  const catalogKey = canonicalNikkeId(catalog, value);
  if (catalogKey) return catalogKey;

  for (const candidate of nikkeIdentifierCandidates(value)) {
    const fallback = fallbackNikkeIdentifier(candidate);
    if (fallback) return fallback;
  }
  return '';
}

export function tetrisDeckDisplayCodes(value = [], catalog = null) {
  return (Array.isArray(value) ? value : [])
    .slice(0, 5)
    .map((item) => {
      const catalogKey = canonicalNikkeId(catalog, item);
      if (catalogKey) return catalogKey;
      if (typeof item === 'string' || typeof item === 'number') return text(item);
      return text(
        item?.nikkeId
        ?? item?.nikke_id
        ?? item?.resourceId
        ?? item?.resource_id
        ?? item?.gameCharacterId
        ?? item?.game_character_id
        ?? item?.characterId
        ?? item?.character_id
        ?? item?.tid
        ?? item?.nameCode
        ?? item?.name_code
        ?? item?.code
        ?? item?.id
        ?? item?.name,
      );
    })
    .filter(Boolean);
}

export function canonicalTetrisDeckKeys(value = [], catalog = null) {
  return (Array.isArray(value) ? value : [])
    .slice(0, 5)
    .map((item) => canonicalTetrisNikkeKey(item, catalog))
    .filter(Boolean);
}

export function canonicalTetrisMemberKey(value = {}) {
  if (typeof value === 'string' || typeof value === 'number') return text(value);
  const direct = text(
    value.memberOpenid
    ?? value.member_openid
    ?? value.openid
    ?? value.normalizedOpenid
    ?? value.normalized_openid
    ?? value.memberId
    ?? value.member_id
    ?? value.userId
    ?? value.user_id,
  );
  if (direct) return direct;
  const nickname = text(value.nickname ?? value.memberNickname ?? value.member_nickname);
  return nickname ? `nickname:${nickname.toLocaleLowerCase('ko-KR')}` : '';
}

export function mergeTetrisCodeSets(...values) {
  const merged = new Set();
  for (const value of values) {
    const source = value instanceof Set ? [...value] : Array.isArray(value) ? value : [];
    for (const item of source) {
      const key = canonicalTetrisNikkeKey(item);
      if (key) merged.add(key);
    }
  }
  return merged;
}
